let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9hU7e")).then(() => parcelRequire('kr3A7'));